import type { HTMLAttributes, ReactElement } from 'react';

import type { Interpolation, Theme } from '@emotion/react';
import { useTheme } from '@emotion/react';

import * as styles from './modal-image.styles';

type Props = {
  css?: Interpolation<Theme>
  children: ReactElement;
} & HTMLAttributes<HTMLDivElement>;

export const ModalImage = ({ children, css: customCss, ...other }: Props) => {
  const theme = useTheme();

  return (
    <div css={[styles.elementImage(theme), customCss]} data-testid="modal-image" {...other}>
      {children}
    </div>
  );
};
